import * as React from 'react';
import { useQuery, useQueryClient } from 'react-query';

import { REPORTS_API_ROUTE } from '@/api-routes/reports';
import { axiosInstance } from '@/axios';

const QUERY_KEY = 'needl-report-ask-needl-questions';

export const useGetInitialQuestions = ({
  feedId,
  enabled = true,
}: useGetInitialQuestionsType) => {
  return useQuery([QUERY_KEY, feedId], () => fetcher(feedId), {
    select: (data) => data.results,
    enabled: !!feedId && enabled,
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  });
};

export const useInvalidateInitialQuestions = () => {
  const queryClient = useQueryClient();

  return React.useCallback(
    (feedId: string) => {
      return queryClient.invalidateQueries({
        queryKey: [QUERY_KEY, feedId],
        exact: true,
      });
    },
    [queryClient]
  );
};

const fetcher = async (board_id: string) => {
  const response = await axiosInstance.get<ApiResponse>(
    REPORTS_API_ROUTE.questions(),
    {
      params: {
        board_id,
      },
    }
  );
  return response.data;
};

type useGetInitialQuestionsType = {
  feedId: string;
  enabled?: boolean;
};

type InitialQuestionsType = Record<string, string[]>;

type ApiResponse = {
  results: InitialQuestionsType;
};
